import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-hero-gradient text-brand-white py-24 px-6 md:py-32 overflow-hidden" data-id="element-102">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-104">
          <span className="inline-block text-brand-gold font-bold tracking-widest text-sm uppercase mb-6" data-id="element-105">
            PRECIO DE LANZAMIENTO — TIEMPO LIMITADO
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1,
        ease: 'easeOut'
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6" data-id="element-106">
          El sistema completo que le falta al 90% de las esteticistas para
          cobrar lo que merecen y llenar la agenda sin depender del boca a boca
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-2xl font-sans font-light text-brand-white/90 mb-10 max-w-3xl mx-auto" data-id="element-107">
          6 guías profesionales + 6 herramientas exclusivas. Todo lo que
          necesitás para profesionalizar tu consultorio desde hoy.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col items-center justify-center gap-4" data-id="element-108">
          <a href="https://gana-con-conocimiento.myshopify.com/cart/52148248248603:1" className="w-full sm:w-auto px-10 py-5 bg-brand-gold text-brand-white text-lg font-bold rounded-full hover:bg-brand-gold/90 transition-all duration-300 shadow-lg hover:shadow-brand-gold/30 hover:-translate-y-1" data-id="element-109">
            Quiero el Megapack — $19.990
          </a>
          <a href="https://gana-con-conocimiento.myshopify.com/cart/52148953874715:1" className="text-brand-white/70 hover:text-brand-white text-sm mt-2 transition-colors duration-300 underline underline-offset-4" data-id="element-110">
            o la Edición Avanzada con material de especialización por $27.990 →
          </a>
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20" data-id="element-111">
        <div className="absolute top-[-10%] left-[-10%] w-96 h-96 rounded-full bg-brand-gold blur-3xl mix-blend-screen" data-id="element-112"></div>
        <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 rounded-full bg-brand-purple blur-3xl mix-blend-screen" data-id="element-113"></div>
      </div>
    </section>;
}